// Action type constants for the Gate Pass module (TblGatePass).
// Naming mirrors your existing accessoriesPoInwardHeader.actionsType.js style.

export const GATE_PASS_LOADING = 'GATE_PASS_LOADING';

export const FETCH_GATE_PASS_MASTER_SUCCESS = 'FETCH_GATE_PASS_MASTER_SUCCESS'; // grid list
export const FETCH_SINGLE_GATE_PASS_SUCCESS = 'FETCH_SINGLE_GATE_PASS_SUCCESS'; // single record -> edit form
export const FETCH_GATE_PASS_STATUS_DROPDOWN_SUCCESS = 'FETCH_GATE_PASS_STATUS_DROPDOWN_SUCCESS';

export const CREATE_GATE_PASS_FORM = 'CREATE_GATE_PASS_FORM'; // generic "set one field" reducer, like createAccessoriesPoInwardMasterForm

export const SET_UNIT_NAME_GATE_PASS = 'SET_UNIT_NAME_GATE_PASS';
export const SET_START_DATE_GATE_PASS = 'SET_START_DATE_GATE_PASS';
export const SET_END_DATE_GATE_PASS = 'SET_END_DATE_GATE_PASS';

export const GATE_PASS_USERFORM_RESET = 'GATE_PASS_USERFORM_RESET';

export const FETCH_PENDING_STYLE_SALE_ORDER_SUCCESS = 'FETCH_PENDING_STYLE_SALE_ORDER_SUCCESS'; // Style/SubStyle/SaleOrder lookup grid
export const FETCH_PENDING_STYLE_SALE_ORDER_REQUEST = 'FETCH_PENDING_STYLE_SALE_ORDER_REQUEST'; // Style/SubStyle/SaleOrder lookup grid
export const FETCH_PENDING_STYLE_SALE_ORDER_FAILURE = 'FETCH_PENDING_STYLE_SALE_ORDER_FAILURE'; // Style/SubStyle/SaleOrder lookup grid

// ---- Gate Pass Details (detail page, same pattern as General DC details) ----
export const NAVIGATE_GATE_PASS_DETAILS = 'NAVIGATE_GATE_PASS_DETAILS'; // open detail page for one gate pass
export const NAVIGATE_GATE_PASS_MASTER = 'NAVIGATE_GATE_PASS_MASTER'; // back to the gate pass list
export const GATE_PASS_DETAILS_LOADING = 'GATE_PASS_DETAILS_LOADING';
export const FETCH_GATE_PASS_DETAILS_SUCCESS = 'FETCH_GATE_PASS_DETAILS_SUCCESS'; // detail rows of the selected gate pass
export const CREATE_GATE_PASS_DETAILS_FORM = 'CREATE_GATE_PASS_DETAILS_FORM'; // set one field on the detail form
export const SET_GATE_PASS_DETAILS_FORM = 'SET_GATE_PASS_DETAILS_FORM'; // load a whole row into the form (edit)
export const GATE_PASS_DETAILS_FORM_RESET = 'GATE_PASS_DETAILS_FORM_RESET';
export const NAVIGATE_GATE_PASS_PRINT = 'NAVIGATE_GATE_PASS_PRINT'; // open the print page for one gate pass
export const GATE_PASS_AUTHORIZED_SUCCESS = 'GATE_PASS_AUTHORIZED_SUCCESS'; // gate pass authorized from the print page
